import { add } from 'lodash';
import { BillingAddressComponent } from '../components';
import Address from '../entities/Address'
export class AddressUtil  {
    constructor() 
    { 
        
    }
  
    public static isAddressPopulated(address: Address): boolean{
        var val: boolean;
        if (address.StreetNumber && address.StreetNumber.trim().length > 0){val = true};
        if (address.StreetName && address.StreetName.trim().length > 0){val = true};
        if (address.City && address.City.trim().length > 0){val = true};
        if (address.PostalCode  && address.PostalCode.trim().length > 0){val = true};
        if (address.POBoxNumber && address.POBoxNumber.trim().length > 0){val = true};
        if (address.StateID && address.StateID > 0){val = true};
        if (address.ID && address.ID > 0){val = true};
        return val;
    }

    public static compareAddresses(address1: Address, address2: Address): boolean{
        var val: boolean;
        if(address1.StreetName == address2.StreetName 
            && address1.City == address2.City 
            && address1.PostalCode == address2.PostalCode 
            && address1.StateID == address2.StateID) {
            val = true; 
        } else {
            val = false;
        }
        return val;
    }

    public static isEssentialAddressPopulated(address : Address): boolean{
        var val: boolean;
        if (address.StreetName && address.StreetName.trim().length > 0 &&
            address.City && address.City.trim().length > 0 &&
            address.PostalCode  && address.PostalCode.trim().length > 0 &&
            address.StateID && address.StateID > 0){
                val = true;
        }
        return val;
    }
}